import { Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { toggleSearchMenu } from '../../state/actions';
import { getSelectedFilterCount } from '../../state/utils';
import { StateType } from '../../../state/state.types';
import { SEARCH_TYPES_WITH_FILTERS } from '../../searchContansts';

const mapState = ({ queryParams, user, results }: StateType) => ({
  selectedFiltersLength: getSelectedFilterCount({ queryParams }),
  hasFilters: SEARCH_TYPES_WITH_FILTERS.includes(queryParams.type),
  totalHits: results.totalHits,
  displayed: results.totalHits > -1 && !user.trialExpired,
  trialExpired: user.trialExpired,
  type: queryParams.type,
  isSearchLoading: results.searchLoading,
  query: queryParams.userQuery,
});

const mapDispatch = (dispatch: Dispatch) => ({
  openFilter() {
    dispatch(toggleSearchMenu());
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
